<!-- Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. -->

<form mat-dialog-content [formGroup]="formGroup" (ngSubmit)="onNext()">
	<p>{{ appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_INSTRUCTIONS }}</p>
	<button
		class="link-btn"
		mat-button
		color="primary"
		type="button"
		(click)="onLearnMoreClick(learnMoreTemplate)"
	>
		{{ appStrings.UICONTROL_TEXT_LEARNMORE }}
	</button>
	<div>
		<mat-extended-select [option$]="modeSelectOptions$" [labelPath]="[]" formControlName="modeSelect">
		</mat-extended-select>
	</div>
	<div>
		<mat-extended-select
			[required]="false"
			[option$]="varianceList$"
			[labelPath]="['varianceReason']"
			[valuePath]="['$id']"
			[placeholder]="appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_VARIANCE_REASON_LABEL"
			formControlName="varianceReason"
			[includeFilter]="true"
			[iconBackgroundColorPath]="['varianceColor']"
		>
		</mat-extended-select>
	</div>
	<div>
		<mat-form-field class="import-tickets-variances-comment">
			<mat-label>{{ appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_VARIANCE_COMMENT_LABEL }}</mat-label>
			<textarea
				matInput
				formControlName="varianceComment"
				class="import-tickets-variances-comment-input"
				matTextareaAutosize
				[cdkTextareaAutosize]="false"
				[rows]="3"
			></textarea>
		</mat-form-field>
	</div>
	<div class="import-tickets-variances-apply">
		<button (click)="onApplyVarianceReason()" mat-raised-button type="button" color="primary">
			{{ appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_APPLY_BUTTON }}
		</button>
	</div>
	<div>
		<checkbox-list formControlName="needVarianceCheckList" checkboxSide="left" class="variance-check-list">
			<checkbox-set
				[label]="appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_SELECT_ALL_LABEL"
				class="select-all-checkbox-set"
			></checkbox-set>
			<ng-container *ngFor="let ticketCheck of ticketsCheckList$ | async">
				<checkbox-list-item [id]="ticketCheck.id" class="ticket-checkbox-list-item">
					<ng-template customCheckboxContent let-handleClick="handleClickFn">
						<div class="custom-content-wrapper">
							<mat-icon
								(click)="handleClick()"
								[fontIcon]="ticketCheck.originalModel?.icon"
								[ngClass]="ticketCheck.originalModel?.iconClass"
								>{{ ticketCheck.originalModel?.icon }}
							</mat-icon>
							<div
								class="custom-content-ticket-data"
								(click)="focusTicket(ticketCheck.originalModel?.ticket)"
							>
								<h4 class="ticket-activity-name">
									{{ ticketCheck.originalModel?.ticket?.view?.activityName }}
								</h4>
								<div class="ticket-details">
									<span
										>{{ ticketCheck.originalModel?.ticket?.view?.liveStart }} -
										{{ ticketCheck.originalModel?.ticket?.view?.liveFinish }}</span
									>
									<span *ngIf="ticketCheck.originalModel?.swimlaneBelonging?.view?.label">
										{{ appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_SWIMLANE_LABEL }}:
										{{ ticketCheck.originalModel.swimlaneBelonging?.view?.label }}</span
									>
								</div>
							</div>
						</div>
					</ng-template>
				</checkbox-list-item>
				<mat-divider></mat-divider>
			</ng-container>
		</checkbox-list>
	</div>
</form>

<mat-divider class="padded-divider"></mat-divider>

<!-- Footer -->
<button-footer
	mat-dialog-actions
	(buttonSaveOrClose)="onNext()"
	[saveOrCloseButtonText]="appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_NEXT_LABEL"
>
	<button leftButton type="button" mat-button mat-dialog-close color="primary" automationId="cancel">
		{{ appStrings.UICONTROL_TEXT_CANCEL.toUpperCase() }}
	</button>
</button-footer>

<ng-template #importCannotBeProcessedTemplate>
	<dialog-titlebar
		[showIconButton]="false"
		[title]="appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_PROCESSING_REQUIREMENTS_TITLE"
	></dialog-titlebar>
	<div mat-dialog-content>
		<p>{{ appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_PROCESSING_REQUIREMENTS }}</p>
	</div>
</ng-template>
<ng-template #learnMoreTemplate>
	<dialog-titlebar
		[showIconButton]="false"
		[title]="appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_UPDATING_PROMISED_TICKET_INSTRUCTIONS"
	></dialog-titlebar>
	<div mat-dialog-content>
		<p>{{ appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_VARIANCE_REASON_REQUIRED }}</p>
		<div class="learn-more-instructions">
			<div>
				<p>
					{{ appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_ASSIGN_VARIANCE_REASON_INSTRUCTIONS_LINE_1 }}
				</p>
				<ul>
					<li>
						{{
							appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_ASSIGN_VARIANCE_REASON_INSTRUCTIONS_LINE_2
						}}
					</li>
					<li>
						{{
							appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_ASSIGN_VARIANCE_REASON_INSTRUCTIONS_LINE_3
						}}
					</li>
					<li>
						{{
							appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_ASSIGN_VARIANCE_REASON_INSTRUCTIONS_LINE_4
						}}
					</li>
					<li>
						{{
							appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_ASSIGN_VARIANCE_REASON_INSTRUCTIONS_LINE_5
						}}
					</li>
				</ul>
			</div>
			<div>
				<mat-form-field class="full-width">
					<mat-select
						[placeholder]="appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_VARIANCE_REASON_LABEL"
						disabled="true"
					></mat-select>
				</mat-form-field>
				<mat-form-field class="import-tickets-variances-comment">
					<mat-label>{{
						appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_VARIANCE_COMMENT_LABEL
					}}</mat-label>
					<textarea
						matInput
						class="import-tickets-variances-comment-input"
						matTextareaAutosize
						[cdkTextareaAutosize]="false"
						[rows]="3"
						disabled="true"
					></textarea>
				</mat-form-field>
			</div>
		</div>
		<p>{{ appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_EXCLUDE_DATES_INSTRUCTIONS_LINE_1 }}</p>
		<ul>
			<li>{{ appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_EXCLUDE_DATES_INSTRUCTIONS_LINE_2 }}</li>
			<li>{{ appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_EXCLUDE_DATES_INSTRUCTIONS_LINE_3 }}</li>
			<li>{{ appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_EXCLUDE_DATES_INSTRUCTIONS_LINE_4 }}</li>
		</ul>
		<p>{{ appStrings.IMPORT_TICKET_MAP_VARIANCE_REASONS_STEP_ASSIGN_VARIANCE_ON_DATE_EXCLUDED }}</p>
	</div>
</ng-template>
